// --------------------------------------------------------------

// Custom Modals

// --------------------------------------------------------------

class CustomModal {
    constructor(modalId, triggerElement) {
        this.modal = document.querySelector(`[data-content-type="modal"][data-modal-id="${modalId}"]`);
        if (!this.modal) return;

        this.trigger = triggerElement;
        this.closeTriggers = this.modal.querySelectorAll('[data-action="close-modal"]');
        this.underlay = document.querySelector('.modal-underlay');
        this.body = document.querySelector('body');
        this.addEventListeners();
    }

    addEventListeners() {
        // Open listeners
        if (this.trigger) {
            this.trigger.addEventListener('click', () => this.openModal());
        }
        // Close listeners
        this.closeTriggers.forEach(trigger => {
            trigger.addEventListener('click', () => this.closeModal());
        });
    }

    toggleVisibilityOn(target) {
        target.classList.add('visible');
        setTimeout(() => {
            target.classList.add('transitioned');
        }, 25);
    }

    toggleVisibilityOff(target) {
        target.classList.remove('transitioned');
        setTimeout(() => {
            target.classList.remove('visible');
        }, 375);
    }

    openModal() {
        this.modal.setAttribute('data-modal-open', 'true');
        this.body.classList.add('overflow-hidden-drawer');
        this.toggleVisibilityOn(this.underlay)
        this.toggleVisibilityOn(this.modal);
    }

    closeModal() {
        this.modal.removeAttribute('data-modal-open');
        this.body.classList.remove('overflow-hidden-drawer');
        this.toggleVisibilityOff(this.modal);
        this.toggleVisibilityOff(this.underlay);
    }

}

function closeOpenModals() {
    const openModals = document.querySelectorAll('[data-modal-open="true"]');
    openModals.forEach(modalElement => {
        const modalId = modalElement.getAttribute('data-modal-id');
        const modal = new CustomModal(modalId, modalElement.querySelector(`[data-action="open-modal"][data-modal-id="${modalId}"]`));
        modal.closeModal();
    });
}

function createModalUnderlay() {
    if (document.querySelector('.modal-underlay')) return;

    const underlay = document.createElement('div');
    underlay.classList.add('modal-underlay');
    underlay.classList.add('color-background-4');
    document.querySelector('body').appendChild(underlay);
    underlay.addEventListener('click', closeOpenModals);
}

function initCustomModals() {
    const triggers = document.querySelectorAll(`[data-action="open-modal"]`);
    if (triggers.length === 0) return;

    createModalUnderlay();

    triggers.forEach(trigger => {
        const modalId = trigger.getAttribute('data-modal-id');
        if (!document.querySelector(`[data-modal-id="${modalId}"]`).getAttribute('data-initialized')) {
            new CustomModal(modalId, trigger);
            document.querySelector(`[data-modal-id="${modalId}"]`).setAttribute('data-initialized', 'true');
        }
    });
}

document.addEventListener('DOMContentLoaded', initCustomModals);

// --------------------------------------------------------------

// Custom Chat Triggers

// --------------------------------------------------------------

function initChatTriggers() {
    const linkTriggers = document.querySelectorAll('a[href="#start-a-chat"]')
    linkTriggers.forEach(link => {
        convertChatLinkTrigger(link)
    })

    const triggers = document.querySelectorAll('[data-action="open-chat"]')
    triggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
            window.GorgiasChat && window.GorgiasChat.open()
        })
    })
}

function convertChatLinkTrigger(link) {
    link.href = 'javascript:void(0)'
    link.setAttribute('data-action', 'open-chat')
}

document.addEventListener('DOMContentLoaded', initChatTriggers)

// --------------------------------------------------------------

// Cart Terms & Conditions

// --------------------------------------------------------------

function initCartTerms() {
    const inputs = document.querySelectorAll('[data-action="toggle-terms"]')
    inputs.forEach(input => {
        input.addEventListener('change', (event) => {
            handleTermsChange(event.target, inputs)
        })
    })
}

function handleTermsChange(target, inputs) {
    inputs.forEach(input => {
        if (input != target) {
            input.checked = target.checked
        }
    })
    const checkoutButtons = document.querySelectorAll('button[type="submit"][name="checkout"]');
    checkoutButtons.forEach(button => {
        button.disabled = !target.checked
    })
    const walletButtons = document.querySelectorAll('.dynamic-checkout__content');
    walletButtons.forEach(button => {
        button.classList.toggle('hidden', !target.checked)
    })
}

document.addEventListener('DOMContentLoaded', initCartTerms)